import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  userPickerInputLabel: {
    id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-picker.user-picker-input-label',
    defaultMessage: 'Search user name or group',
    description: 'Label for the user picker in the form permission configuration modal.'
  },
  add: {
    id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-picker.add',
    defaultMessage: 'Add',
    description: 'Add button text for the form permission configuration modal to add a principal.'
  },
  error: {
    id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-picker.error',
    defaultMessage: 'Error loading users and groups',
    description: 'Error message displayed in the picker when we failed to load the users and groups.'
  },
  ariaLabel: {
    id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-picker.aria-label',
    defaultMessage: 'User and group picker',
    description: 'Aria label for the user and group picker in the form permission configuration modal.'
  }
});